const notificationsType = {
    CREATE_NOTIFICATION: 'CREATE_NOTIFICATION',
    CREATE_NOTIFICATION_COMMIT: 'CREATE_NOTIFICATION_COMMIT',
    CREATE_NOTIFICATION_ROLLBACK: 'CREATE_NOTIFICATION_ROLLBACK'
};

export default notificationsType;